export const definedTranslation = {
  title: {
    id: 'project-selection-modal-main-title',
    defaultMessage: 'Which Project Are You Working On Today?',
  },
  createProjectTitle: {
    id: 'project-selection-modal-create-project-title',
    defaultMessage: 'Create New Project',
  },
  createProjectButton: {
    id: 'project-selection-modal-create-project-button',
    defaultMessage: 'Create New Project',
  },
  saveButton: {
    id: 'project-selection-modal-save-button',
    defaultMessage: 'Save',
  },
  allProjectsHeader: {
    id: 'project-selection-modal-all-projects-title',
    defaultMessage: 'All Projects',
  },
  searchProjectsLabel: {
    id: 'project-selection-modal-search-projects-label',
    defaultMessage: 'Search',
  },
  seeMoreButton: {
    id: 'project-selection-modal-see-more-button',
    defaultMessage: 'See More',
  },
  seeLessButton: {
    id: 'project-selection-modal-see-less-button',
    defaultMessage: 'See Less',
  },
  noResultsMessage: {
    id: 'project-selection-modal-no-results-text',
    defaultMessage: 'No Results',
  },
  itemNotAddedToCartMessage: {
    id: 'item-not-added-to-cart',
    defaultMessage: 'Item Not Added to Cart',
  },
  createProjectForm: {
    fields: {
      name: {
        id: 'project-selection-create-project-form-field-name-label',
        defaultMessage: 'Name',
      },
      namePlaceholder: {
        id: 'project-selection-create-project-form-field-name-placeholder',
        defaultMessage: 'Enter project name',
      },
      type: {
        id: 'project-selection-create-project-form-field-type-label',
        defaultMessage: 'Type',
      },
      phase: {
        id: 'project-selection-create-project-form-field-phase-label',
        defaultMessage: 'Phase',
      },
      location: {
        id: 'project-selection-create-project-form-field-location-label',
        defaultMessage: 'Location',
      },
      description: {
        id: 'project-selection-create-project-form-field-description-label',
        defaultMessage: 'Description',
      },
      descriptionPlaceholder: {
        id: 'project-selection-create-project-form-field-description-placeholder',
        defaultMessage: 'Description',
      },
    },
    errors: {
      requredNameErrorText: {
        id: 'project-selection-create-project-form-error-required-name',
        defaultMessage: 'Name is a required field',
      },
      requiredDescriptionErrorText: {
        id: 'project-selection-create-project-form-error-required-description',
        defaultMessage: 'Description is a required field',
      },
      invalidCharErrorText: {
        id: 'project-selection-create-project-form-error-invalid-chars',
        defaultMessage: 'An invalid character has been entered',
      },
    },
    descriptionHelperText: {
      id: 'project-selection-create-project-form-field-description-helper-text',
      defaultMessage:
        'Please include the type of project, location (city, state) and approximate square footage. Project descriptions are shared with brands.',
    },
    exampleText: {
      id: 'project-selection-create-project-example-text',
      defaultMessage:
        'Headquarter renovation in Chicago. Around 17,000 sf of office space with ancillary hospitality/break out zones. Focused neutral colored materials throughout.',
    },
    cancelButton: {
      id: 'project-selection-create-project-form-cancel-button',
      defaultMessage: 'Cancel',
    },
    saveButton: {
      id: 'project-selection-create-project-form-save-button',
      defaultMessage: 'Save',
    },
  },
};
